import { render, staticRenderFns } from "./AboutTabs.vue?vue&type=template&id=5b73761e&scoped=true"
import script from "./AboutTabs.vue?vue&type=script&lang=js"
export * from "./AboutTabs.vue?vue&type=script&lang=js"
import style0 from "./AboutTabs.vue?vue&type=style&index=0&id=5b73761e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b73761e",
  null
  
)

export default component.exports